import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const patrimonialIndicatorsFields: FieldInterface[] = [
  {
    key: 'assetsHolding',
    originKey: 'assets_holding',
    type: FIELD_TYPES.object,
  },
  {
    key: 'wealthProjection',
    originKey: 'wealth_projection',
    type: FIELD_TYPES.object,
  },
  {
    key: 'wealthDistribution',
    originKey: 'wealth_distribution',
    type: FIELD_TYPES.object,
  },
  {
    key: 'leverageRatio',
    originKey: 'leverage_ratio',
    type: FIELD_TYPES.object,
  },
  {
    key: 'debtRate',
    originKey: 'debt_rate',
    type: FIELD_TYPES.object,
  },
  {
    key: 'deathBenefits',
    originKey: 'death_benefits',
    type: FIELD_TYPES.object,
  },
  {
    key: 'precautionarySavings',
    originKey: 'precautionary_savings',
    type: FIELD_TYPES.object,
  },
  {
    key: 'liquidity',
    originKey: 'liquidity',
    type: FIELD_TYPES.object,
  },
  {
    key: 'riskLevel',
    originKey: 'risk_level',
    type: FIELD_TYPES.object,
  },
  {
    key: 'lifeExpenses',
    originKey: 'life_expenses',
    type: FIELD_TYPES.object,
  },
  {
    key: 'inheritance',
    originKey: 'inheritance',
    type: FIELD_TYPES.object,
  },
  {
    key: 'retirement',
    originKey: 'retirement',
    type: FIELD_TYPES.object,
  },
  {
    key: 'savingsCapacity',
    originKey: 'savings_capacity',
    type: FIELD_TYPES.object,
  },
  {
    key: 'loanCapacity',
    originKey: 'loan_capacity',
    type: FIELD_TYPES.object,
  },
  {
    key: 'loanCapacityPrimaryResidence',
    originKey: 'loan_capacity_primary_residence',
    type: FIELD_TYPES.object,
  },
  {
    key: 'loanCapacityRentalProperty',
    originKey: 'loan_capacity_rental_property',
    type: FIELD_TYPES.object,
  },
  {
    key: 'taxes',
    originKey: 'taxes',
    type: FIELD_TYPES.object,
  },
]

const patrimonialIndicatorsRelations: RelationInterface[] = []

export { patrimonialIndicatorsFields, patrimonialIndicatorsRelations }
